<div class="header-popup" [ngClass]="{ 'header-popup--sidenav': isSideNavStyle }">
  <ng-content></ng-content>
</div>
